import * as React from 'react';
import { Container } from '../../components/Container';
import { SIZE_16, SIZE_4 } from '../../constants/sizes';
import { SeoSubtitles } from '../../components/SeoSubtitles/SeoSubtitles';
import { ArticleParagraph3 } from '@cian/ui-kit';
import { getSubtitles } from '../../selectors/seo/getSubtitles';
import { useSelector } from 'react-redux';
import { getIsFilterUpcomingSaleEnabled } from '../../selectors/location';

export const Subheading = () => {
  const subtitles = useSelector(getSubtitles);
  const isInfoSection = useSelector(getIsFilterUpcomingSaleEnabled);

  return (
    <>
      {subtitles && <SeoSubtitles subtitles={subtitles} />}
      {isInfoSection && (
        <Container margin={`${SIZE_4} 0 0 ${SIZE_16}`}>
          <ArticleParagraph3 color="gray40_100">Информационный раздел</ArticleParagraph3>
        </Container>
      )}
    </>
  );
};
